import { initials } from '@/lib/format'
import { cn } from '@/lib/cn'

const sizes = {
  sm: 'size-8 text-xs',
  /** Ukuran foto pada kiriman Threads. */
  utas: 'size-9 text-xs',
  md: 'size-10 text-sm',
  lg: 'size-14 text-base',
  xl: 'size-20 text-xl',
}

export function Avatar({
  name,
  src,
  size = 'md',
  className,
}: {
  name: string
  src?: string
  size?: keyof typeof sizes
  className?: string
}) {
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={cn('rounded-full border border-line object-cover', sizes[size], className)}
        loading="lazy"
      />
    )
  }

  return (
    <span
      aria-hidden
      title={name}
      className={cn(
        'inline-flex items-center justify-center rounded-full bg-sunken font-semibold text-muted',
        sizes[size],
        className,
      )}
    >
      {initials(name)}
    </span>
  )
}
